import { render, staticRenderFns } from "./Duplicates.vue?vue&type=template&id=02007654&scoped=true"
import script from "./Duplicates.vue?vue&type=script&lang=js"
export * from "./Duplicates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02007654",
  null
  
)

export default component.exports